module.exports = __webpack_public_path__ + "img/Gordon-Food-Service.545a43fe.jpg";